module.exports = __webpack_public_path__ + "static/media/02_BOJO_MEIA_TACA_LISO_05.13fb1a4b.jpg";